import { Component } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';

@Component({
    selector: 'app-loading',
  imports: [CarouselModule],
    standalone: true,
    templateUrl: '../ui/loading.component.html'
})
export class LoadingComponent {
  wittyText: string[] = [
    'Searching for gaffer tape',
    'Packing spare pair of socks number 4',
    'Has anyone seen the tent poles?',
    'Spirit gum? Check.',
    'Facepaint needs replacing',
    'Packing spare pair of socks number 13',
    'Is this ear on straight?',
    'Learning in-character languages',
    'Another pack of tent pegs',

  ]
  shuffledText: string[];
  shuffle = (array: string[]) => { 
    for (let i = array.length - 1; i > 0; i--) { 
      const j = Math.floor(Math.random() * (i + 1)); 
      [array[i], array[j]] = [array[j], array[i]]; 
    } 
    return array; 
  }; 

  constructor() {
    this.shuffledText = this.shuffle(this.wittyText);
  }
}
